import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import CreateTicketForm from './CreateTicketForm';

const CreateTicketDialog = ({ open, onOpenChange, trip }) => {
  const handleSubmit = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[720px] w-full max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Submit Field Corrections</DialogTitle>
          <DialogDescription>
            Raise a correction request for trip {trip?.tripNumber || trip?.trip_number || 'N/A'}.
          </DialogDescription>
        </DialogHeader>
        
        {open && trip && (
          <CreateTicketForm 
            trip={trip} 
            onSubmit={handleSubmit} 
            onCancel={() => onOpenChange(false)} 
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CreateTicketDialog;
